module.exports = __webpack_public_path__ + "static/media/bluestone.897d9d7b.svg";